import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HttpService } from "../service/http-service";
import { API } from "../config/api-config";
declare var alertify: any;
@Component({
  selector: "app-app-manager",
  templateUrl: "./app-manager.component.html",
  styleUrls: ["./app-manager.component.css"],
})
export class AppManagerComponent implements OnInit {
  public data: any = [];

  constructor(private router: Router, private http: HttpService) {}

  ngOnInit() {
    this.getList();
  }

  public editManager(id) {
    this.router.navigate(["index/appmanager", id]);
  }

  private getList() {
    this.http.getData(API.appManager).then((res) => {
      if (res.status.code == 0) {
        this.data = res.data;
      }
    });
  }

  public deleteManager(id) {
    let _self = this;
    alertify.confirm(
      "删除",
      "確定要刪除嗎？",
      function () {
        _self.http.deleteData(API.appManager + "/" + id).then((res) => {
          if (res.status.code == 0) {
            alertify.success(res.status.message);
            _self.getList();
          } else {
            alertify.error(res.status.message);
          }
        });
      },
      function () {}
    );
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/app-manager/app-manager.component.ts